<template>
    <div class="commodity-detail-page">
        <el-row type="flex" class="row-bg commodity-detail-page-top" justify="space-between">
            <el-col>
                <img class="detail-page-return-button" src="../../../assets/images/goBack.png" width="60" height="28" alt="返回" @click="returnList">
            </el-col>
            <el-col class="commodity-detail-page-save">
                <el-button class="sn-search-button" type="primary" :loading="saveLoading" size="mini" @click="saveData">保存</el-button>
            </el-col>
        </el-row>
        <div class="commodity-detail-page-head">
            <el-form ref="ruleForm" :model="formListData" :rules="verification" label-position="right" label-width="100px">
                <el-col :span="content.span ? content.span : 5" v-for="(content, index) in inFoList" :key="index">
                    <el-form-item :label="content.label" :prop="content.prop">
                        <div v-if="content.amendState && amendState">
                            <el-input v-model="formListData[content.prop]" disabled></el-input>
                        </div>
                        <div v-else>
                            <el-input v-if="content.type==='textarea'" resize="none" type="textarea" :rows="content.rows || 4" placeholder="请输入内容"
                            v-model="formListData[content.prop]"></el-input>
                            <el-select v-else-if="content.type==='select'" v-model="formListData[content.prop]" filterable>
                                <el-option v-for="(val, index) in content.options" :key=index :label="val.label" :value="val.value"></el-option>
                            </el-select>
                            <el-input v-else-if="content.type==='number'" v-model.number="formListData[content.prop]" clearable></el-input>
                            <el-input v-else v-model="formListData[content.prop]" clearable></el-input>
                        </div>
                    </el-form-item>
                </el-col>
            </el-form>
        </div>
        <div class="commodity-detail-page-bottom">
            <div class="commodity-detail-page-buttonList">
                <el-button class="detail-page-operation-button" :disabled="!buttonDisabled" :loading="refreshLoading" @click="refresh" type="primary" plain>刷新</el-button>
                <el-button class="detail-page-operation-button" :disabled="!buttonDisabled" @click="addRow" type="primary" plain>新增</el-button>
                <el-button class="detail-page-operation-button" :disabled="!buttonDisabled" :loading="deleteLoading" type="danger" plain @click="deleteRow">删除</el-button>
            </div>
            <el-table
            border
            height="200px"
            class="commodity-detail-page-table"
            ref="moduleTable"
            :data="tableData"
            @selection-change="handleSelectionChange">
            <el-table-column v-if="tableConfig.selectBtn" type="selection" width="40" fixed></el-table-column>
            <el-table-column v-if="tableConfig.lineBtn" type="index" label="行号" width="50"></el-table-column>
            <el-table-column
                :key='item.prop'
                :prop='item.prop'
                :label='item.label'
                show-overflow-tooltip
                :min-width="item.width||''"
                v-for="item in inFoTable">
                <template v-slot="scope">
                    <div v-if="scope.row.edit !== EDIT_TYPE.CANCEL && item.require">
                        <template v-if="!item.type">{{scope.row[item.prop]}}</template>
                        <el-input  v-else-if="item.type === 'input'" v-model="scope.row[item.prop]" clearable></el-input>
                        <el-input
                        class="commodity-input-number"
                        v-else-if="item.type === 'number'"
                        type="number"
                        onkeyup="value=value.replace(/^\D*/g, '')"
                        @keydown.native="channelInputLimit"
                        v-model.number="scope.row[item.prop]" clearable></el-input>
                        <el-input v-else-if="item.type === 'advance'" v-model="scope.row[item.prop]" readonly>
                            <i slot="suffix" class="el-input__icon el-icon-search" @click="detaliSearch(scope.$index)"></i>
                        </el-input>
                        <el-select clearable v-else-if="item.type === 'select'" v-model="scope.row[item.prop]" filterable>
                            <el-option v-for="(val, index) in item.options" :key=index :label="val.label" :value="val.value"></el-option>
                        </el-select>
                    </div>
                    <div v-else>
                        {{dataFormat(scope.row,item)}}
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="操作" fixed="right" :width="tableConfig.leftWidth||'120px'" v-if="tableConfig.leftOperation">
                <template v-slot="scope">
                    <template v-for="(e, eIndex) in tableConfig.action">
                        <el-button v-if="e.displayRule(scope.row, EDIT_TYPE)" type="text" size="mini" :key="eIndex"
                            @click.stop="actionClick(e.event, scope.row, scope.$index)">{{e.label}}
                        </el-button>
                    </template>
                    <el-button size="mini" type="text" v-if="scope.row.edit === EDIT_TYPE.CANCEL"
                    @click.stop="btnEvent(scope.row,'edit',scope.$index)">编辑</el-button>
                    <el-button size="mini" type="text" v-else
                    @click.stop="btnEvent(scope.row,'cancel',scope.$index)">取消</el-button>
                </template>
            </el-table-column>
            </el-table>
            <!-- 分页组件 -->
        <el-row type="flex" class="row-bg" justify="space-between">
            <el-col :span="12" class="page-text">
                <div>
                    {{$translate('lang.E3202102230003', { defaultText: '已选' })}}
                    <span class="text-color">&nbsp;&nbsp;{{checkedNum}}&nbsp;&nbsp;</span>
                    {{$translate('lang.E3202101270008', { defaultText: '项' })}}
                </div>
                <slot name="page-module-btn"></slot>
            </el-col>
            <el-col :span="12">
                <Npage ref="page" id="paging"
                    :currentPage="currentPage"
                    :pageData="tableConfig.page"
                    :total="pageTotal"
                    @on-page-change="pageChange"
                    @on-size-change="sizeChange">
                </Npage>
            </el-col>
            </el-row>
        </div>
        <div slot="detail-page-dialog" class="btn-box">
            <slot name="detail-page-dialog"></slot>
        </div>
    </div>
</template>
<script>
import _ from 'lodash';
import Npage from '../../../components/IdentityComponent/mPage/Main';
import { dictWithUrl } from '../../../components/basicDataDialog/api';
export default {
    props: {
        type: {
            type: String,
            default() {
                return '';
            }
        },
        apiList: {
            type: Object,
            default() {
                return {};
            }
        },
        formData: {
            type: Object,
            default() {
                return {};
            }
        },
        inFoList: {
            type: Array,
            default() {
                return [];
            }
        },
        amendState: {
            type: Boolean,
            default() {
                return false;
            }
        },
        verification: {
            type: Object,
            default() {
                return {};
            }
        },
        inFoTable: {
            type: Array,
            default() {
                return [];
            }
        },
        tableConfig: {
            type: Object,
            default() {
                return {};
            }
        },
        currentPage: {
            type: Number,
            default() {
                return 1;
            }
        },
        saveItemValid: {
            type: Function,
            default: function(row, formListData) {
                return true;
            }
        }
    },
    components: { Npage },
    computed: {
        buttonDisabled() {
            return this.formListData.id;
        },
        checkedNum() {
            return this.selected.length;
        },
        validEditList() {
            return this.tableData.filter(item => item.edit === this.EDIT_TYPE.EDIT);
        }
    },
    data() {
        return {
            EDIT_TYPE: { EDIT: 2, CANCEL: -3 },
            saveLoading: false,
            refreshLoading: false,
            deleteLoading: false,
            tableData: [],
            selected: [],
            errorList: [],
            formListData: {},
            pageNo: 1,
            pageSize: 10,
            pageTotal: 0,
            currentIndex: ''
        };
    },
    methods: {
        returnList() {
            this.$emit('returnList');
        },
        saveData() {
            if (!this.apiList.saveApi) {
                return;
            }
            if (this.validEditList.length) {
                this.$message.warning('请先保存明细信息');
                return;
            }
            const params = this.formListData;
            this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    this.saveLoading = true;
                    this.apiList.saveApi(params).then(res => {
                        if (res && +res.code === 0) {
                            this.$set(this.formListData, 'id', res.data);
                            this.$message.success(`保存成功`);
                            this.$emit('saveSuccess');
                        }
                    }).finally(() => {
                        this.saveLoading = false;
                    });
                }
            });
        },
        refresh() {
            if (!this.apiList.getDetailApi) {
                return;
            }
            this.refreshLoading = true;
            this.loadData();
        },
        loadData() {
            if (!this.apiList.getDetailApi) {
                return;
            }
            const params = {
                pageNo: this.pageNo,
                pageSize: this.pageSize,
                ruleGroupCode: this.formListData.ruleGroupCode,
                ruleCode: this.formListData.ruleCode
            };
            this.apiList.getDetailApi(params).then(res => {
                if (res && +res.code === 0) {
                    this.tableData = this.dataInit(res.data.list);
                    this.pageTotal = res.data.totalCount;
                }
            }).finally(() => {
                this.refreshLoading = false;
            });
        },
        pageChange(data) {
            this.pageNo = data;
            this.loadData();
        },
        sizeChange(data) {
            this.pageSize = data;
            this.loadData();
        },
        channelInputLimit(e) {
            const key = e.key;
            // 不允许输入'e'和'.'
            if (key === '——' || key === '-' || key === 'e' || key === 'E') {
                e.returnValue = false;
                return false;
            }
            return true;
        },
        addRow() {
            if (this.validEditList.length === 1) {
                this.$message.warning('请先保存后再新增&编辑！');
                return;
            }
            // 新增一行，并进入行内编辑模式
            const obj = {};
            this.inFoTable.forEach(item => {
                obj[item.prop] = item.defaultValue || '';
            });
            obj.edit = this.EDIT_TYPE.EDIT;
            this.tableData.unshift(obj);
            // 新增默认勾选
            this.$refs.moduleTable.toggleRowSelection(obj, true);
        },
        deleteRow() {
            if (!this.selected.length) {
                this.$message.warning('请勾选数据');
                return;
            }
            const idList = [];
            this.selected.forEach(item => {
                if (item.id) {
                    idList.push(item.id);
                }
            });
            if (!idList.length) {
                this.refresh();
                this.$message.success(`删除成功`);
            } else {
                this.deleteLoading = true;
                this.apiList.deleteDetailApi(idList).then(res => {
                    if (res && +res.code === 0) {
                        this.$message.success(`删除成功`);
                        this.refresh();
                    }
                }).finally(() => {
                    this.deleteLoading = false;
                });
            }
        },
        handleSelectionChange(selection) {
            this.selected = selection;
        },
        dataInit(list) {
            const tableList = list || [];
            tableList.forEach((item, index) => {
                item.serialNum = index;
                if (item.id) {
                    this.$set(tableList[index], 'edit', this.EDIT_TYPE.CANCEL);
                }
            });
            return tableList;
        },
        btnEvent(selection, event, index) {
            if (event === 'edit' && this.validEditList.length === 1) {
                this.$message.warning('请先保存后再新增&编辑！');
                return;
            }
            if (event === 'edit' || event === 'cancel') {
                // 状态取反
                selection.edit = ~selection.edit;
                if (selection.edit === this.EDIT_TYPE.CANCEL) {
                    if (!selection.id) {
                        this.tableData.splice(selection.serialNum, 1);
                    } else if (selection.backup) {
                        this.$set(this.tableData, index, selection.backup);
                        this.$set(this.tableData[index], 'edit', this.EDIT_TYPE.CANCEL);
                    }
                } else {
                    selection.backup = _.clone(selection);
                    this.$refs.moduleTable.toggleRowSelection(selection, true);
                }
            }
        },
        actionClick(event, row, rIndex) {
            if (event === 'save') {
                if (!this.formListData.id) {
                    this.$message.warning('请先保存头部信息');
                    return;
                }
                this.saveItem(row);
            }
        },
        setItem(param) {
            const currentData = this.tableData[this.currentIndex];
            this.tableData[this.currentIndex] = Object.assign(currentData, param);
        },
        saveValid(row) {
            let ModifyData = _.cloneDeep([row]).map(item => {
                delete item.backup;
                delete item.edit;
                return item;
            });
            if (!this.tableExamine(ModifyData)) {
                ModifyData = false;
            }
            return ModifyData;
        },
        saveItem(row) {
            if (!this.saveValid(row)) {
                return;
            };
            if (this.type === 'BarCodeRuleGroup') {
                row.ruleCode = this.formListData.ruleCode;
            } else {
                row.ruleGroupCode = this.formListData.ruleGroupCode;
            }
            if (!this.saveItemValid(row, this.formListData)) {
                return;
            }
            this.apiList.saveDetailApi(row).then(res => {
                if (res && +res.code === 0) {
                    this.$message.success(`保存成功`);
                    this.loadData();
                }
            });
        },
        tableExamine(data) {
            let errorHint = false;
            let errorMsg = '';
            // 重置错误提醒对象
            this.errorList = this.tableData.map(item => {
                return Array(Object.keys(item).length).fill(false);
            });
            data.forEach(data => {
                this.inFoTable.forEach((column, index) => {
                    const propIsNecessary = data.notNecessaryProps ? !data.notNecessaryProps.includes(column.prop) : column.mustFill;
                    const notNull = !data[column.prop];
                    if (propIsNecessary) {
                        if (notNull) {
                            errorHint = true;
                            errorMsg += (column.label + ',');
                        }
                    }
                });
            });
            if (errorHint) {
                errorMsg = errorMsg.substr(0, errorMsg.length - 1) + '不能为空';
                this.$message.warning(errorMsg);
            }
            return !errorHint;
        },
        handleMdInputChange(data, row) {
            Object.assign(row, data);
        },
        detaliSearch(index) {
            this.currentIndex = index;
            this.$emit('detaliSearch');
        },
        async getOptionList(columnsList) {
            const optionList = [];
            const numList = [];
            columnsList.forEach((columns, index) => {
                if (columns.optionNum) {
                    optionList.push(columns.optionNum);
                    numList.push(index);
                }
            });
            if (optionList.length) {
                const list = await dictWithUrl(optionList.join(','));
                const optiondata = optionList.map(num => {
                    const option = [];
                    for (const key in list.data[num]) {
                        if (list.data[num].hasOwnProperty(key)) {
                            const currentItem = list.data[num][key];
                            option.push({ 'value': currentItem.code, 'label': currentItem.name });
                        }
                    }
                    return option;
                });
                numList.forEach((data, index) => {
                    columnsList[data].options = optiondata[index];
                });
            }
        },
        dataFormat(row, col) {
            if (!col.options) {
                return row[col.prop];
            };
            const currentItem = col.options.filter(item => item.value === row[col.prop])[0];
            return currentItem ? currentItem.label : row[col.prop];
        }
    },
    mounted() {
        if (this.formData.status || this.formData.status === 0) {
            this.formData.status = (this.formData.status).toString();
        };
        this.formListData = this.formData;
        this.getOptionList(this.inFoList);
        this.getOptionList(this.inFoTable);
        this.formListData.id && this.loadData();
    }
};
</script>
<style lang="less">
.commodity-detail-page{
    display: flex;
    flex-direction: column;
    .el-table{
        min-height: calc(100vh - 437px) !important;
        max-height: calc(100vh - 437px) !important;
        .el-icon-search{
            color: #4285f5;
            cursor: pointer;
        }
    }
    .commodity-detail-page-head{
        padding: 20px;
        margin: 10px 10px 0;
        box-shadow: inset 0px -0.5px 0px 0px rgba(216,216,216,1);
        background: #ffffff;
    }
    .detail-page-return-button{
        cursor: pointer;
    }
    .detail-page-operation-button{
        width: 48px;
        height: 28px;
        padding: 0;
        border: 1.5px solid;
        background: none;
    }
    .detail-page-operation-button.is-disabled,
    .el-button.is-disabled:hover,
    .el-button.is-disabled:focus{
        background: none;
        border: 1.5px solid #e1e5e6;
        color: #999999;
    }
    .commodity-detail-page-bottom{
        padding: 20px;
        margin: 0 10px 10px;
        background: #ffffff;
    }
    .commodity-detail-page-table{
        margin-bottom: 20px;
    }
    .commodity-detail-page-save{
        text-align: right;
    }
    .commodity-detail-page-top{
        padding: 10px 20px;
        background: #ffffff;
    }
    .commodity-detail-page-buttonList{
        margin-bottom: 20px;
    }
    .el-table--border {
        border: 1px solid #EBEEF5;
    }
    .page-text{
      display: flex;
      >div{
        height: 28px;
        line-height: 28px;
        font-size: 12px;
        margin-right: 10px;
        .text-color{
          color: #4285f5;
        }
      }
    }
    /* 去掉右侧上下箭头  */
    .commodity-input-number {
        input::-webkit-outer-spin-button,
        input::-webkit-inner-spin-button {
            -webkit-appearance: none;
        }
        input[type='number'] {
            -moz-appearance: textfield;
        }
    }
}
</style>